import { render } from "./comp-authorization.vue?vue&type=template&id=0fd97f26&scoped=true"
import script from "./comp-authorization.vue?vue&type=script&lang=js"
export * from "./comp-authorization.vue?vue&type=script&lang=js"

import "./comp-authorization.vue?vue&type=style&index=0&id=0fd97f26&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd97f26"]])

export default __exports__